import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Box, BoxProps, Typography } from '@mui/material';

import { PropertyDetailsHighlight } from '../PropertyDetailsHighlight';
import { QuestionEntry } from './QuestionEntry';

import { COMMON_QUESTIONS, CommonQuestionsKeys } from '../config/commonQuestionsConfig';

export interface CommonQuestionsProps extends BoxProps {
  commonQuestionsKeys: CommonQuestionsKeys[];
}

export const CommonQuestions = ({ commonQuestionsKeys, ...rest }: CommonQuestionsProps) => {
  const commonQuestionConfigs = useMemo(
    () => commonQuestionsKeys.map((key) => COMMON_QUESTIONS[key]),
    [commonQuestionsKeys]
  );

  return (
    <Box {...rest}>
      <PropertyDetailsHighlight>
        <Typography variant="h6">
          <FormattedMessage id="common-questions" defaultMessage="Common Questions" />
        </Typography>
      </PropertyDetailsHighlight>
      <Box my={{ xs: 2, md: 3 }} mx={{ xs: 0, md: 3 }} sx={{ backgroundColor: 'background.default' }}>
        {commonQuestionConfigs.map(({ title, link, description }, index) => (
          <QuestionEntry key={index} question={title} link={link} description={description} />
        ))}
      </Box>
    </Box>
  );
};
